// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bhh_a bhv_h","Menu__offsetParent":"bhh_b bhv_bj","Menu__trigger--shadowed":"bhh_c"};